import bookingStateSelector from '../../selectors/BookingStateSelector';
import { updateLocalBookingState } from '../../actions/SchedulingActions';

import {
    getMentalHealthRequirement,
    getNonMentalHealthRequirements,
    hasMentalHealthRequirement,
} from './utils';
import { setMentalHealthQuestionnaire } from '../../pages/ReviewAndBook/actions';

export function setMentalHealthRequirementValue(checkboxes) {
    return (dispatch, getState) => {
        const state = getState();
        const bookingState = bookingStateSelector(state);
        if (hasMentalHealthRequirement(bookingState)) {
            const selected = Object.keys(checkboxes).filter(k => checkboxes[k]);
            const selectedObj = selected.reduce((accumulator, currentValue) => {
                accumulator[currentValue] = true;
                return accumulator;
            }, {});
            const requirement = getMentalHealthRequirement(bookingState);
            const otherRequirements = getNonMentalHealthRequirements(
                bookingState
            );

            dispatch(
                updateLocalBookingState({
                    ...bookingState,
                    requirements: [
                        ...otherRequirements,
                        { ...requirement, value: selected.length > 0 },
                    ],
                })
            );
            dispatch(
                setMentalHealthQuestionnaire(
                    selected.length > 0 ? selectedObj : null
                )
            );
        }
    };
}
